<section>
    <div class="mx-auto max-w-7xl">
        @if (productResource.isLoading()) {
            <div class="flex lg:flex-row flex-col gap-8">
                <div class="flex flex-col gap-4">
                    <ngx-skeleton-loader
                        class="lg:w-[700px] h-96"
                        [theme]="{ height: '100%' }"
                    ></ngx-skeleton-loader>
                    <ngx-skeleton-loader
                        class="flex gap-4"
                        [theme]="{ height: '115px', width: '200px' }"
                        count="3"
                    ></ngx-skeleton-loader>
                </div>
                <div class="flex flex-col gap-8 w-full">
                    <ngx-skeleton-loader
                        [theme]="{ height: '3.25rem', width: '100%' }"
                    ></ngx-skeleton-loader>
                    <ngx-skeleton-loader
                        [theme]="{ height: '1.5rem', width: '100%' }"
                    ></ngx-skeleton-loader>
                    <ngx-skeleton-loader
                        [theme]="{ height: '2rem', width: '100%' }"
                    ></ngx-skeleton-loader>
                    <ngx-skeleton-loader
                        [theme]="{ height: '3rem', width: '100%' }"
                    ></ngx-skeleton-loader>
                </div>
            </div>
        } @else {
            @if (
                productResource.value() &&
                productResource.value()!.data.length > 0
            ) {
                @let product = productResource.value()!.data[0];
                @if (productService.isFullySoldOut(product)) {
                    <div
                        class="flex flex-col items-center gap-8 space-y-4 md:space-y-6 p-6 sm:p-8"
                    >
                        <img
                            src="images/Logo_Zehentmoar_RGB.svg"
                            alt="Zehentmoar logo"
                            class="h-24"
                        />
                        <h3 class="font-semibold text-black text-2xl">
                            {{ "product.outOfStock" | translate }}
                        </h3>
                        <p
                            class="font-normal text-gray-500 text-lg text-center"
                        >
                            {{ "product.currentlyOutOfStock" | translate }}
                        </p>
                        <a
                            [routerLink]="[
                                '/',
                                languageService.getLanguageCode,
                                'hof',
                                'shop',
                            ]"
                        >
                            <app-button size="small"
                                >{{ "footer.toShop" | translate }}
                            </app-button>
                        </a>
                    </div>
                } @else {
                    <div class="grid grid-cols-1 lg:grid-cols-2 ~gap-0/16">
                        <div
                            class="lg:top-28 lg:sticky mx-0 max-lg:mx-auto w-full h-fit"
                        >
                            <a
                                [routerLink]="[
                                    '/',
                                    languageService.getLanguageCode,
                                    'hof',
                                    'shop',
                                ]"
                                [queryParams]="{
                                    category: product.category.slug,
                                }"
                                queryParamsHandling="merge"
                                class="block mb-4"
                                ><app-button
                                    size="small"
                                    (click)="
                                        umami.track(
                                            'full-product-shop-button-click'
                                        )
                                    "
                                    translate
                                    [translateParams]="{
                                        category: product.category.name,
                                    }"
                                >
                                    {{ getCategoryName() }}
                                </app-button></a
                            >
                            <div class="relative ~mb-4/6">
                                @if (selectedImage()) {
                                    <img
                                        [src]="
                                            domHandler.generateSrcsetAsWebp(
                                                selectedImage()
                                            )
                                        "
                                        [srcset]="
                                            domHandler.generateSrcsetAsWebp(
                                                selectedImage()
                                            )
                                        "
                                        alt="{{
                                            selectedImage()?.alternativeText
                                        }} produkt bild"
                                        class="max-lg:mx-auto rounded-2xl max-h-[50vh] lg:max-h-[75vh] object-cover"
                                    />
                                } @else {
                                    <div
                                        class="bg-gray-200 rounded-2xl w-full h-[400px]"
                                    ></div>
                                }
                            </div>
                            <div
                                class="flex gap-4 ~max-h-32/40"
                                [ngClass]="{
                                    'justify-between':
                                        (product.images?.length || 0) > 3,
                                }"
                            >
                                @for (image of product.images; track $index) {
                                    <img
                                        [src]="
                                            domHandler.generateSrcsetAsWebp(
                                                image
                                            )
                                        "
                                        [srcset]="
                                            domHandler.generateSrcsetAsWebp(
                                                image
                                            )
                                        "
                                        alt="{{
                                            image.alternativeText
                                        }} produkt bild"
                                        (click)="selectImage(image)"
                                        class="border hover:border-primary rounded-xl max-w-[30%] object-cover transition-all duration-500 cursor-pointer"
                                        [ngClass]="{
                                            'border-primary border-2':
                                                selectedImage()?.documentId ===
                                                image.documentId,
                                        }"
                                    />
                                }
                            </div>
                        </div>
                        <div
                            class="relative max-lg:mx-auto max-lg:mt-8 w-full max-lg:max-w-[608px]"
                        >
                            <div class="gap-2 grid grid-cols-[1fr,max-content]">
                                <div class="row-span-3 mb-8">
                                    <h2
                                        class="mb-2 font-bold text-black text-3xl"
                                    >
                                        {{ product.name }}
                                    </h2>

                                    <p
                                        class="mb-4 font-normal text-gray-500 text-base"
                                    >
                                        {{ product.category.name }}
                                    </p>

                                    <h5
                                        class="font-semibold text-black text-2xl"
                                    >
                                        {{ price() | customPrice }}
                                    </h5>
                                    <p class="text-gray-700 text-xs">
                                        {{ "product.inclVat" | translate }}
                                    </p>
                                </div>
                                @if (product.category.image) {
                                    <img
                                        [src]="
                                            domHandler.getSmallestImage(
                                                product.category.image
                                            )
                                        "
                                        [srcset]="
                                            domHandler.generateSrcset(
                                                product.category.image
                                            )
                                        "
                                        alt="{{
                                            product.category.image
                                                .alternativeText
                                        }} produkt bild"
                                        class="place-self-end row-span-2 max-w-52 ~max-h-24/36 h-full lg:size-full object-contain object-top ~/lg:~w-32/52"
                                    />
                                }
                            </div>

                            <p class="mb-2 font-medium text-black text-lg">
                                @if (product.inventoryType === "weight") {
                                    {{ "product.chooseWeight" | translate }}
                                } @else {
                                    {{ "product.chooseVariant" | translate }}
                                }
                            </p>
                            <div class="gap-3 grid grid-cols-3 mb-6 max-w-sm">
                                @for (
                                    variant of product.variants;
                                    track $index
                                ) {
                                    @if (variant.amount > 0) {
                                        <p
                                            class="hover:bg-gray-50 p-1 border-2 border-gray-300 hover:border-primary rounded-lg min-[400px]:h-[100px] text-gray-700 text-center transition-all duration-500 cursor-pointer"
                                            (click)="selectVariant(variant)"
                                            [ngClass]="{
                                                'border-primary':
                                                    selectedVariant()?.uuid ===
                                                    variant.uuid,
                                            }"
                                        >
                                            {{
                                                productService.getVariantLabel(
                                                    product,
                                                    variant
                                                )
                                            }}
                                        </p>
                                    } @else {
                                        <p
                                            class="bg-gray-400 p-1 border-2 border-gray-300 hover:border-red-500 rounded-lg min-[400px]:h-[100px] text-gray-700 text-center transition-all duration-500 cursor-not-allowed"
                                            [ngClass]="{
                                                'border-primary':
                                                    selectedVariant()?.uuid ===
                                                    variant.uuid,
                                            }"
                                        >
                                            {{
                                                productService.getVariantLabel(
                                                    product,
                                                    variant
                                                )
                                            }}
                                        </p>
                                    }
                                }
                            </div>

                            @if (product.deliveryDates.length === 0) {
                                <svg
                                    width="800"
                                    height="800"
                                    class="inline-block fill-green-500 mb-6 size-8"
                                    viewBox="0 0 32 32"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g />
                                    <path
                                        d="M16 2.672C8.639 2.672 2.672 8.639 2.672 16S8.64 29.328 16 29.328c7.361 0 13.328-5.967 13.328-13.328S23.361 2.672 16 2.672m0 25.59C9.239 28.262 3.738 22.761 3.738 16S9.238 3.738 16 3.738c6.761 0 12.262 5.501 12.262 12.262S22.762 28.262 16 28.262"
                                    />
                                    <path
                                        d="m22.667 11.241-8.559 8.299-2.998-2.998a.8.8 0 0 0-1.131 1.131l3.555 3.555a.797.797 0 0 0 1.121.009l9.124-8.848a.8.8 0 0 0-1.113-1.149z"
                                    />
                                </svg>
                                <p
                                    class="inline-block bottom-2 relative mb-3 ml-2 font-medium text-black text-lg"
                                >
                                    {{ "product.available" | translate }}
                                </p>
                            } @else {
                                <p class="mb-2 font-medium text-black text-lg">
                                    {{
                                        "product.chooseDeliveryDate" | translate
                                    }}
                                </p>
                                <select
                                    class="bg-white mb-6 px-4 py-3 border border-gray-400 rounded-lg cursor-pointer"
                                    autocomplete="off"
                                    [ngModel]="selectedDeliveryDate()"
                                    (ngModelChange)="selectDeliveryDate($event)"
                                >
                                    @for (
                                        date of product.deliveryDates;
                                        track $index
                                    ) {
                                        <option [ngValue]="date">
                                            {{ date.date | customDate }}
                                        </option>
                                    }
                                </select>
                            }

                            <p class="mb-2 font-medium text-black text-lg">
                                {{ "product.chooseAmount" | translate }}
                            </p>
                            <div
                                class="flex justify-center items-center mb-4 border border-gray-400 rounded-full w-full h-[50px]"
                            >
                                <button
                                    class="group flex justify-center items-center bg-white hover:bg-gray-50 shadow-sm shadow-transparent hover:shadow-gray-300 px-3 py-[14px] border-gray-400 border-r rounded-l-full w-full h-full transition-all duration-300"
                                    (click)="decreaseQuantity()"
                                >
                                    <svg
                                        class="stroke-black group-hover:stroke-black"
                                        width="22"
                                        height="22"
                                        viewBox="0 0 22 22"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M16.5 11H5.5"
                                            stroke=""
                                            stroke-width="1.6"
                                            stroke-linecap="round"
                                        />
                                        <path
                                            d="M16.5 11H5.5"
                                            stroke=""
                                            stroke-opacity="0.2"
                                            stroke-width="1.6"
                                            stroke-linecap="round"
                                        />
                                        <path
                                            d="M16.5 11H5.5"
                                            stroke=""
                                            stroke-opacity="0.2"
                                            stroke-width="1.6"
                                            stroke-linecap="round"
                                        />
                                    </svg>
                                </button>
                                <input
                                    type="text"
                                    class="bg-transparent px-2 py-3 outline-0 w-full min-[400px]:min-w-[75px] h-full font-semibold text-black hover:placeholder:text-primary hover:text-primary placeholder:text-black text-lg text-center"
                                    placeholder="1"
                                    value="{{ amount() }}"
                                    (blur)="setAmount($event)"
                                />
                                <button
                                    class="group flex justify-center items-center bg-white hover:bg-gray-50 shadow-sm shadow-transparent hover:shadow-gray-300 px-3 py-[14px] border-gray-400 border-l rounded-r-full w-full h-full transition-all duration-300"
                                    (click)="increaseQuantity()"
                                >
                                    <svg
                                        class="stroke-black group-hover:stroke-black"
                                        width="22"
                                        height="22"
                                        viewBox="0 0 22 22"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M11 5.5V16.5M16.5 11H5.5"
                                            stroke="#9CA3AF"
                                            stroke-width="1.6"
                                            stroke-linecap="round"
                                        />
                                        <path
                                            d="M11 5.5V16.5M16.5 11H5.5"
                                            stroke="black"
                                            stroke-opacity="0.2"
                                            stroke-width="1.6"
                                            stroke-linecap="round"
                                        />
                                        <path
                                            d="M11 5.5V16.5M16.5 11H5.5"
                                            stroke="black"
                                            stroke-opacity="0.2"
                                            stroke-width="1.6"
                                            stroke-linecap="round"
                                        />
                                    </svg>
                                </button>
                            </div>

                            <div
                                class="bottom-0 left-0 z-20 lg:z-auto fixed lg:relative w-full"
                            >
                                <div
                                    class="flex min-[400px]:flex-row flex-col items-center gap-3 min-[400px]:mb-8 lg:mb-3"
                                >
                                    <button
                                        class="group flex justify-center items-center gap-2 bg-gray-50 hover:bg-gray-200 shadow-sm hover:shadow-gray-300 mt-4 px-5 py-4 border border-gray-200 lg:rounded-full w-full font-semibold text-primary text-lg transition-all duration-500"
                                        (click)="
                                            cartService.addToCart(
                                                {
                                                    product: product,
                                                    selectedVariant:
                                                        selectedVariant()!,
                                                    selectedDeliveryDate:
                                                        selectedDeliveryDate(),
                                                    amount: amount(),
                                                },
                                                $event
                                            )
                                        "
                                    >
                                        <svg
                                            class="stroke-primary group-hover:stroke-primary transition-all duration-500"
                                            width="22"
                                            height="22"
                                            viewBox="0 0 22 22"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M10.7394 17.875C10.7394 18.6344 10.1062 19.25 9.32511 19.25C8.54402 19.25 7.91083 18.6344 7.91083 17.875M16.3965 17.875C16.3965 18.6344 15.7633 19.25 14.9823 19.25C14.2012 19.25 13.568 18.6344 13.568 17.875M4.1394 5.5L5.46568 12.5908C5.73339 14.0221 5.86724 14.7377 6.37649 15.1605C6.88573 15.5833 7.61377 15.5833 9.06984 15.5833H15.2379C16.6941 15.5833 17.4222 15.5833 17.9314 15.1605C18.4407 14.7376 18.5745 14.0219 18.8421 12.5906L19.3564 9.84059C19.7324 7.82973 19.9203 6.8243 19.3705 6.16215C18.8207 5.5 17.7979 5.5 15.7522 5.5H4.1394ZM4.1394 5.5L3.66797 2.75"
                                                stroke=""
                                                stroke-width="1.6"
                                                stroke-linecap="round"
                                            />
                                        </svg>
                                        {{ "product.addToCart" | translate }}
                                    </button>
                                </div>
                                <button
                                    class="flex justify-center items-center bg-primary hover:bg-primary-darker shadow-sm shadow-transparent hover:shadow-primary px-5 py-4 lg:rounded-full w-full font-semibold text-white text-lg text-center transition-all duration-500"
                                    (click)="revalidateItem()"
                                >
                                    @if (isRevalidating()) {
                                        <div
                                            class="inline-block mx-auto border-4 border-current border-t-transparent rounded-full size-8 text-white animate-spin"
                                            role="status"
                                            aria-label="loading"
                                        >
                                            <span class="sr-only"
                                                >Loading...</span
                                            >
                                        </div>
                                    } @else {
                                        {{ "product.buyNow" | translate }}
                                    }
                                </button>
                            </div>

                            <app-rich-text
                                class="block mt-8"
                                [data]="product.description"
                            ></app-rich-text>

                            @if (product.displayGenericText) {
                                <app-divider class="p-0 ~my-8/12"></app-divider>
                                @if (product.inventoryType === "weight") {
                                    <app-rich-text
                                        class="block"
                                        [data]="
                                            shopService.config.value()?.data
                                                ?.weightText
                                        "
                                    ></app-rich-text>
                                }
                                @if (product.inventoryType === "piece") {
                                    <app-rich-text
                                        class="block"
                                        [data]="
                                            shopService.config.value()?.data
                                                ?.pieceText
                                        "
                                    ></app-rich-text>
                                }
                            }

                            @if (data().infoText) {
                                <app-divider class="p-0 ~my-8/12"></app-divider>
                                <app-rich-text
                                    class="block"
                                    [data]="data().infoText"
                                ></app-rich-text>
                            }
                        </div>
                    </div>
                }
            } @else {
                <div
                    class="flex flex-col items-center gap-8 space-y-4 md:space-y-6 p-6 sm:p-8"
                >
                    <img
                        src="images/Logo_Zehentmoar_RGB.svg"
                        alt="Zehentmoar logo"
                        class="h-24"
                    />
                    <h3 class="font-semibold text-black text-2xl">
                        {{ "product.notFound" | translate }}
                    </h3>
                    <p class="font-normal text-gray-500 text-lg">
                        {{ "product.productNotFound" | translate }}
                    </p>
                    <a
                        [routerLink]="[
                            '/',
                            languageService.getLanguageCode,
                            'hof',
                            'shop',
                        ]"
                        queryParamsHandling="preserve"
                    >
                        <app-button size="small"
                            >{{ "footer.toShop" | translate }}
                        </app-button>
                    </a>
                </div>
            }
        }
    </div>
</section>
